import {
  Box,
  Flex,
  FormControl,
  FormErrorMessage,
  FormLabel,
  Tag,
  Text,
  Textarea,
  useDisclosure,
} from "@chakra-ui/react";
import { useEffect, useRef, useState } from "react";
import { useFormContext } from "react-hook-form";
import ContactFieldsList from "../Modals/ContactList";
import PromptTemplateSelect from "./PromptTemplateSelect";
import ConversationFlowSelect from "./ConversationFlowSelect";
import { extractCustomFieldKeywords } from "../../utils/utils";

const Prompt = ({ promptType }) => {
  const [customFieldTags, setCustomFieldTags] = useState([]);
  const [contactTrigger, setContactTrigger] = useState(null);
  const {
    register,
    watch,
    getValues,
    setValue,
    formState: { errors },
  } = useFormContext();
  const systemPrompt = watch("systemPrompt");
  const {
    isOpen: contactIsOpen,
    onOpen: contactOnOpen,
    onClose: contactOnClose,
  } = useDisclosure();

  const inputRef = useRef(null);

  useEffect(() => {
    const keywords = extractCustomFieldKeywords(systemPrompt);
    setCustomFieldTags(keywords);
  }, [systemPrompt]);

  return (
    <Box px={4} py={2}>
      <Flex
        flexDirection={"column"}
        gap={2}
        height={watch("assistant_type") === "simple" ? "95%" : ""}
      >
        {promptType?.value === "conversation_flow" && (
          <Box>
            <ConversationFlowSelect setValue={setValue} watch={watch} />
          </Box>
        )}

        {promptType?.value === "prompt" && (
          <>
            <Box>
              <PromptTemplateSelect setValue={setValue} watch={watch} />
            </Box>
            <Box>
              {customFieldTags.map((keyword, index) => (
                <Tag key={index} colorScheme="blue" mr={2} mb={2}>
                  {keyword}
                </Tag>
              ))}
            </Box>
            <Box>
              <FormControl height={"100%"} isInvalid={errors.systemPrompt}>
                <FormLabel>Prompt</FormLabel>
                <Textarea
                  ref={inputRef}
                  rows={watch("assistant_type") === "simple" ? 27 : 18}
                  placeholder="System Prompt"
                  {...register("systemPrompt", {
                    required: "System Prompt is required",
                  })}
                  resize="vertical"
                  onChange={(e) => {
                    const text = e.currentTarget.value;
                    const lastTyped = e.nativeEvent.data; // the latest typed character
                    const cursorPos = e.currentTarget.selectionStart;
                    setValue("systemPrompt", text, { shouldDirty: true });
                    setValue("conversation_flow_id", null);

                    if (lastTyped === "/") {
                      setContactTrigger({ text, cursorPos }); // store text & cursor
                      contactOnOpen();
                    }
                  }}
                  h={"100%"}
                />

                <Flex justify="space-between" align="center" mt={1}>
                  <Text fontSize="sm" fontStyle="italic">
                    {`To personalize, use your contact, dynamic, or your CRM variables within your prompt. Dynamic variables can just be enclosed within double curly braces. For rest, start by pressing "/"`}
                  </Text>
                  <Text fontSize="xs" color={systemPrompt?.length > 12000 ? "red.500" : "gray.400"} whiteSpace="nowrap" ml={3}>
                    {systemPrompt?.length || 0} chars
                  </Text>
                </Flex>
                <FormErrorMessage>
                  {errors.systemPrompt?.message}
                </FormErrorMessage>
              </FormControl>
            </Box>
          </>
        )}
      </Flex>
      <ContactFieldsList
        getValue={() => getValues("systemPrompt")}
        setValue={setValue}
        isOpen={contactIsOpen}
        onClose={contactOnClose}
        watch={watch}
        trigger={contactTrigger}
      />
    </Box>
  );
};

export default Prompt;
